/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import Vue from 'vue';
import VeeValidate from 'vee-validate';

/**
 * @import { Configuration } from 'vee-validate'
 */

// TODO Část Vue konfigurace probíhá také v Logger.
// - Přidat metodu Logger#addVue a volat ji odsud.
/**
 * Továrna na [instance Vue objektů](https://vuejs.org/v2/guide/instance.html).
 * Stará se o [globální konfiguraci](https://vuejs.org/v2/api/).
 */
export default class VueFactory {
  constructor() {
    Vue.config.productionTip = false;
    Vue.use(
      VeeValidate,
      /** @satisfies {Configuration} */ ({
        // TODO: Původně jsme nastavovali enableAutoClasses místo správného classes
        // (s defaultem false) na hodnotu true, takže to nemohlo odjakživa
        // (od #125 a vee-validate 2.0.9) fungovat. Proto pro ponecháváme raději
        // zakomentované a jen pro referenci.
        // > I reviewed the source code and found that enableAutoClasses has been replaced with classes.
        // - https://github.com/logaretm/vee-validate/issues/723#issuecomment-322034297
        // K přejmenování totiž došlo již ve vee-validate 2.0.0:
        // - https://github.com/logaretm/vee-validate/commit/253971ffaea49b69873e11f2adaebec0ff8dab80
        // classes: true, // Historicky a nesprávně: enableAutoClasses: true
        // Zpracování reakce na události je nedokonalé.
        // Validace se provádí ještě před odesláním formuláře a mate uživatele.
        // Navíc nelze události měnit např. v závislosti na odeslání formuláře.
        // Reakce jsou deaktivovány nastavením "none".
        // Události je třeba sledovat ručně a reagovat na ně dle potřeby.
        events: 'none',
        classNames: {
          valid: 'valid',
          invalid: 'invalid'
        },
        locale: 'en'
      })
    );
    this.Vue = Vue;
  }
}
